export const getCardColor = (matchIdx: number): string => {
  // Distinct base hues for blue, purple, green
  const baseColors = [
    { hue: 200, saturation: 40 }, // soft sky blue
    { hue: 270, saturation: 45 }, // lavender purple
    { hue: 120, saturation: 55 }, // fresher green
  ];

  const baseIndex = matchIdx % baseColors.length;
  const loopCount = Math.floor(matchIdx / baseColors.length);

  const { hue, saturation } = baseColors[baseIndex];

  // Start light and darken each loop
  const baseLightness = 95;
  const darkenStep = 8;
  const lightness = Math.max(70, baseLightness - loopCount * darkenStep);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
